import React from 'react';
import Grid from 'src/app/atoms/Layout/Grid/Grid';
import Stack from 'src/app/atoms/Layout/Stack/Stack';
import HeadingAndSupportingText, {
  HeadingAndSupportingTextProps,
} from 'src/app/molecules/HeadingAndSupportingText/HeadingAndSupportingText';
import SocialProofBadges from 'src/app/molecules/SocialProofBadges/SocialProofBadges';

export interface RankedG2WithTextBlockProps extends HeadingAndSupportingTextProps {
  additionalContent?: React.ReactNode;
}

const RankedG2WithTextBlock = ({ additionalContent, ...headingProps }: RankedG2WithTextBlockProps): JSX.Element => {
  return (
    <Stack
      gap='spacing-4xl'
      gapSm='spacing-6xl'
      directionSm='column'
    >
      <Grid>
        <Stack
          direction='column'
          align='flex-start'
          columns={11}
          columnsMd={12}
        >
          <Stack
            gap='spacing-4xl'
            direction='column'
            align='flex-start'
          >
            <HeadingAndSupportingText {...headingProps} />
          </Stack>
          {additionalContent && <Stack>{additionalContent}</Stack>}
        </Stack>
        <Stack columns={1} />
      </Grid>
      <SocialProofBadges />
    </Stack>
  );
};

export default RankedG2WithTextBlock;
